export function getRootUrl(env: NodeJS.ProcessEnv): string {
    if (env.PREVIEW) {
        return `https://preview-${env.PREVIEW}.dev.luminovo.ai`;
    }
    if (env.ROOT_URL) {
        return env.ROOT_URL;
    }
    if (env.BACKEND_API_HOST) {
        return env.BACKEND_API_HOST;
    }
    if (env.NODE_ENV === 'dev') {
        return 'http://localhost:3000';
    }
    if (Boolean(env.CI_MERGE_REQUEST_IID)) {
        return `https://preview-${env.CI_MERGE_REQUEST_IID}.dev.luminovo.ai`;
    }
    return 'https://ci-e2e.dev.luminovo.ai';
}

export function getExternalApiRootUrl(env: NodeJS.ProcessEnv): string {
    if (env.PREVIEW) {
        return `https://api-preview-${env.PREVIEW}.dev.luminovo.ai`;
    }
    if (env.API_ROOT_URL) {
        return env.API_ROOT_URL;
    }
    if (Boolean(env.CI_MERGE_REQUEST_IID)) {
        return `https://api-preview-${env.CI_MERGE_REQUEST_IID}.dev.luminovo.ai`;
    }
    return 'https://api-ci-e2e.dev.luminovo.ai';
}
